import { HomeFactoryServiceType } from '@/services/factories/homeFactory/interface';
import { HomeFactoryService } from '@/services/factories/homeFactory/HomeFactoryService';

/** Singleton реализация homeFactory **/
const instance: HomeFactoryServiceType = new HomeFactoryService();

export const homeFactory: { (): HomeFactoryServiceType } = () => instance;
